"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Intro_styles_1 = __importDefault(require("./Intro.styles"));
var Button_1 = __importDefault(require("../../../atoms/Button/Button"));
var Intro = function (_a) {
    var username = _a.username, setStep = _a.setStep;
    return (react_1.default.createElement(Intro_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("h1", { className: "title" },
                    "Welkom, ",
                    react_1.default.createElement("br", null),
                    " ",
                    username),
                react_1.default.createElement("p", { className: "intro" }, "Aangezien je voor het eerst in logt vragen we jouw beschikbaarheid door te geven. Wanneer je beschikbaarheid is ingevuld zijn je clinics [vanaf x datum] zichtbaar bij scholen om op in te schrijven."),
                react_1.default.createElement("p", { className: "intro" }, "Je kan aangeven in welke periode jij niet beschikbaar bent dit schooljaar om geeft. Daarna kan je ook per clinic aangeven of deze een afwijkend rooster hebben."),
                react_1.default.createElement(Button_1.default, { className: "button secondary", onClick: function () { return setStep(1); } },
                    react_1.default.createElement("span", null, "Begin met invullen"),
                    react_1.default.createElement("svg", { className: "icon icon-arrow icon-right", "aria-hidden": "true" },
                        react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-right" })))))));
};
exports.default = Intro;
